import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Settings from '../../resources/settings';
import styles from './Navigation.module.css';

const propTypes = {
  urlEndPoint: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  selectedTabEndpoint: PropTypes.string.isRequired,
};

function Tab({ urlEndPoint, displayText, selectedTabEndpoint }) {
  const endpoint = `${Settings.URL_BASE_PATH}${urlEndPoint}`;

  const blockSameTabSelection = (event) => {
    if (urlEndPoint === selectedTabEndpoint) {
      event.preventDefault();
    }
  };

  return (
    <Link
      data-testid="tab-link"
      aria-selected={urlEndPoint === selectedTabEndpoint}
      to={endpoint}
      className={styles['tab']}
      replace={false}
      role="tab"
      onClick={blockSameTabSelection}
      onKeyUp={blockSameTabSelection}
    >
      {displayText}
    </Link>
  );
}

Tab.propTypes = propTypes;

export default Tab;
